import {create} from 'zustand';
import {UseExamReportsStoreProps} from './types';

export const useExamReportsStore = create<UseExamReportsStoreProps>(set => ({
	examRequestData: undefined,
	setExamRequestData: data => set({examRequestData: data}),
	resetExamRequestData: () => set({examRequestData: undefined}),
}));
